// removed by extract-text-webpack-plugin
module.exports = {"component":"_1YzgOQLEk84DM-stZfW1lz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/PriceQuantity/priceQuantity.css
// module id = 459
// module chunks = 2